module.exports = __webpack_public_path__ + "3898d0fdca8eef6d4d587573ec9225a0.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/ppu-hat.jpg
 ** module id = 455
 ** module chunks = 0
 **/